
import { useMatomo } from '@jonkoops/matomo-tracker-react'
import PropTypes from 'prop-types'
import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  QueriesCtx,
} from '$src/components/queries'
import {
  ReportsCtx,
} from '$src/components/reports'


/*
 * ActionsVerticalMenu
**/
const ActionsVerticalMenu = (props) => {
  // logg(props, 'ActionsVerticalMenu')

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()

  /* ctx */

  const {
    deleteModalOpen, setDeleteModalOpen,
    loading, setLoading,
    renameModalOpen, setRenameModalOpen,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ActionsVerticalMenu')

  const {
    shareModalOpen, setShareModalOpen,
    refreshQueriesList,
  } = useContext(QueriesCtx)

  const {
    advancedReportsModalOpen, setAdvancedReportsModalOpen,
    refreshAdvancedReportsList,
    advancedReportEditModalOpen,  setAdvancedReportEditModalOpen,
                                  setReportModalOpen,
    refreshReportsList,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in ActionsVerticalMenu')

  /* methods */

  const handleRefresh = async () => {
    switch(props.kind) {
      case C.kinds.AdvancedReport:
        refreshAdvancedReportsList().then(() => {
          toast('Refreshed Multi FI Reports list')
        })
        break

      case C.kinds.List:
      case C.kinds.Query:
        refreshQueriesList().then(() => {
          toast('Refreshed list of Queries')
        })
        break

      case C.kinds.Report:
        refreshReportsList().then(() => {
          toast('Refreshed Single FI Reports list')
        })
        break

      default:
        throw 'kew - this should never happen'
    }
  }

  const handleClone = async () => {
    setLoading(true)
    switch (selectedResource.kind) {
      case C.kinds.AdvancedReport_financials:
        await fetch(apiRouter.advancedReportClonePath({ id: selectedResource.id }), {
          method: 'Post',
          headers: { 'Content-Type': 'application/json' },
        }).then(r => r.json()).then(inns => {
          toast(`Cloned Multi FI Report`)
        }).catch((err) => {
          logg(err, 'could not clone the report')
          toast('Could not clone the report')
        }).finally(() => {
          setLoading(false)
          refreshAdvancedReportsList()
        })
        break

      case C.kinds.Report:
        await fetch(apiRouter.reportClonePath({ id: selectedResource.id }), {
          method: 'Post',
          headers: { 'Content-Type': 'application/json' },
        }).then(r => r.json()).then(inns => {
          toast(`Cloned Single FI Report`)
        }).catch((err) => {
          logg(err, 'could not clone the report')
          toast('Could not clone the report')
        }).finally(() => {
          setLoading(false)
          refreshReportsList()
        })
        break

      case C.kinds.Query:
      case C.kinds.List:
        await fetch(apiRouter.queryClonePath({ id: selectedResource.id }), {
          method: 'Post',
          headers: { 'Content-Type': 'application/json' },
        }).then(r => r.json()).then(inns => {
          toast(`Cloned List or Query`)
        }).catch((err) => {
          logg(err, 'Could not clone List or Query')
          toast('Could not clone List or Query')
        }).finally(() => {
          setLoading(false)
          refreshQueriesList()
        })
        break

      default:
        throw 't62 - this should never happen.'
    }
  }

  let resourcePath // for Modify!
  if (selectedResource.kind) {
    switch(selectedResource.kind) {
      case C.kinds.AdvancedReport:
      case C.kinds.AdvancedReport_financials:
      case C.kinds.AdvancedReport_fintegration:
        resourcePath = appRouter.advancedReportPath({ id: selectedResource.id })
        break
      case C.kinds.Report:
        resourcePath = appRouter.reportPath({ id: selectedResource.id })
        break
      case C.kinds.Query:
      case C.kinds.List:
        resourcePath = appRouter.queryEditPath({ id: selectedResource.id })
        break
      default:
        throw 't00 - this should not have happened'
    }
  }

  return <div className='actions-vertical'>
    { [C.kinds.AdvancedReport, C.kinds.Report].indexOf(props.kind)!=-1 && <Link to='/'><button className='Btn'
      onClick={() => {
        props.clear()
        switch(props.kind) {
          case C.kinds.Report:
            setReportModalOpen(true)
            break
          case C.kinds.AdvancedReport:
            setAdvancedReportEditModalOpen(true)
            break
          default:
            logg(props, 'props')
            throw '00w - this should never happen'
        }
      } } >New</button></Link> || null }

    { 'mine' === selectedResource.scope &&
      <Link to={resourcePath}>
        <button className='Btn'
          onClick={props.handleModify}
        >Modify</button>
      </Link> ||
      <button className='Btn btn-disabled'>Modify</button> }

    { 'mine' === selectedResource.scope &&
      <button className='Btn ' onClick={() => setRenameModalOpen(true)} >Rename</button> ||
      <button className='Btn btn-disabled'>Rename</button> }

    { selectedResource.id &&
      <button className='Btn ' onClick={handleClone} >Clone</button> ||
      <button className='Btn btn-disabled'>Clone</button> }

    { 'mine' === selectedResource.scope &&
      <button className='Btn ' onClick={() => setDeleteModalOpen(true)} >Delete</button> ||
      <button className='Btn btn-disabled'>Delete</button> }

    { 'mine' === selectedResource.scope &&
      <button className='Btn ' onClick={() => setShareModalOpen(true)} >Share</button> ||
      <button className='Btn btn-disabled'>Share</button> }

    <button className='Btn' onClick={handleRefresh} >Refresh</button>
  </div>
}
export default ActionsVerticalMenu
ActionsVerticalMenu.propTypes = {
  clear:        PropTypes.func.isRequired,
  handleModify: PropTypes.func.isRequired,
  kind:         PropTypes.string.isRequired,
};
